import React from 'react'
import AttendanceTable from './AttendanceTable'
import { Card } from 'reactstrap'

const AttendanceManagement = () => {
  return (
    <Card className='p-3'>
      <AttendanceTable />
    </Card>
  )
}

export default AttendanceManagement